import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { isTokenExpired, refreshToken, getUserDetails } from './AuthUtil';
import loadingimg from '../Assets/images/loading image 1.png';
import { CircularProgress } from '@mui/material';
import { teleConsultationModel } from '../Axios/AxiosConfig';

const cookies = new Cookies();

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const userDetailsRef = useRef(getUserDetails());

  // 1. Check authentication only once on mount
  useEffect(() => {
    const checkAuthentication = async () => {
      let accessToken = cookies.get('accessToken');

      // Try to refresh if token is expired or missing
      if (!accessToken || isTokenExpired(accessToken)) {
        const refreshed = await refreshToken();
        accessToken = cookies.get('accessToken');

        if (!refreshed || !accessToken || isTokenExpired(accessToken)) {
          setIsAuthenticated(false);
          return;
        }
      }

      setIsAuthenticated(true);
    };

    checkAuthentication();
  }, []);

  // 2. If authenticated, fetch doctor details. If not, redirect to login
  useEffect(() => {
    if (isAuthenticated === false) {
      navigate('/login', { state: { from: location } });
    }

    if (isAuthenticated === true) {
      const fetchDoctorDetails = async () => {
        try {
          const id = userDetailsRef.current?.UID;

          if (!id) return;

          const response = await teleConsultationModel.get(`getDoctor_details/${id}`);
          if (response.status === 200) {
            const { about, ...doctorDataWithoutAbout } = response.data;

            cookies.set('Doctor_details', JSON.stringify(doctorDataWithoutAbout), {
              path: '/',
              sameSite: 'lax'
            });

          }
        } catch (error) {
          console.error('Error fetching doctor details:', error);
        }
      };

      fetchDoctorDetails();
    }
  }, [isAuthenticated]); // only depends on this to avoid infinite loop

  // 3. While authentication is loading
  if (isAuthenticated === null) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh'
      }}>
        <div style={{ position: 'relative', width: '10rem', height: '10rem' }}>
          <CircularProgress style={{ width: '100%', height: '100%', color: '#DA6E0B' }} thickness={1} />
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}>
            <img src={loadingimg} style={{ width: '80%', height: '80%' }} alt="Loading" />
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

export default ProtectedRoute;
